import { AuditableStatus } from '../../enums';

export interface IComment {
    id?: string;
    comment: string;
    createdBy: string;
    createdAt?: string;
    updatedAt?: string;
}

export interface IAuditable {
    comments: IComment[];
    createdBy?: string;
    resolvedBy?: string;
    resolvedAt?: string;
    status: AuditableStatus;
}
